import { render, staticRenderFns } from "./TeachRoomDetail.vue?vue&type=template&id=16866879&scoped=true&"
import script from "./TeachRoomDetail.vue?vue&type=script&lang=js&"
export * from "./TeachRoomDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeachRoomDetail.vue?vue&type=style&index=1&id=16866879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16866879",
  null
  
)

export default component.exports